import type { FC } from 'react'
import styled from 'styled-components'

import Section from './Section'
import type { Filter as SectionFilterT } from './SectionFilter'
import SectionFilter, { DEFAULT_FILTER as DEFAULT_SECTION_FILTER } from './SectionFilter'

const Subtitle = styled.h4`
  margin-bottom: 5px;
`

export interface Filter {
  paye: SectionFilterT
  other: SectionFilterT
}

export const DEFAULT_FILTER: Filter = {
  paye: DEFAULT_SECTION_FILTER,
  other: DEFAULT_SECTION_FILTER,
}

interface Props {
  filter: Filter
  onChangeFilter: (sectionFilters: Filter) => void
}

const IncomeSectionFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <>
    <Section>
      <Subtitle>PAYE</Subtitle>
      <SectionFilter
        filter={filter.paye}
        onChangeFilter={newFilter => onChangeFilter({ ...filter, paye: newFilter })}
      />
    </Section>
    <Section>
      <Subtitle>Other</Subtitle>
      <SectionFilter
        filter={filter.other}
        onChangeFilter={newFilter => onChangeFilter({ ...filter, other: newFilter })}
      />
    </Section>
  </>
)

export default IncomeSectionFilter
